import Vue from 'vue';
import Vuex from 'vuex';

import rewardWheel from './store/rewardwheel';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    rewardWheel
  },
});

export default store;
